import { Matrix4Tuple } from 'three'

import { Identifiable, PointArray } from './attribute'
import { LineStyle } from './canvas/enums'

export enum DrawingType {
  Polyline = 'polyline',
  Polygon = 'polygon',
  Circle = 'circle',
  TextAnnotation = 'annotation',
  MeasurementLabel = 'measurement',
}

export enum DrawingStyle {
  StrokeColor = 'strokeColor',
  StrokeWidth = 'strokeWidth',
  StrokeStyle = 'strokeStyle',
  FillColor = 'fillColor',
  TextColor = 'textColor',
  TextSize = 'textSize',
  TextOffset = 'textOffset',
}

export enum PolygonSubtype {
  Polygon = 'polygon',
  Rectangle = 'rectangle',
}

export type DrawingStyles = {
  [DrawingStyle.StrokeColor]?: string
  [DrawingStyle.StrokeWidth]?: number
  [DrawingStyle.StrokeStyle]?: LineStyle
  [DrawingStyle.FillColor]?: string
  [DrawingStyle.TextColor]?: string
  [DrawingStyle.TextSize]?: number
  [DrawingStyle.TextOffset]?: number
}

export interface DrawingParameters {
  uuid: string
  transformation: Matrix4Tuple
  styles: Partial<DrawingStyles>
  order: number | null
}

export interface DrawingParameterPolyline extends DrawingParameters {
  points: PointArray[]
}

export interface DrawingParameterPolygon extends DrawingParameters {
  subtype?: PolygonSubtype
  center: PointArray
  points: PointArray[]
  vertices: [number, number][]
}

export interface DrawingParameterCircle extends DrawingParameters {
  center: PointArray
  radius: number
}

export interface DrawingParameterRectangle extends DrawingParameterPolygon {
  subtype: PolygonSubtype.Rectangle
  width?: number
  height?: number
}

export interface TextAnnotationLeadAnchor extends Identifiable {
  point: PointArray
  inspectionItemId?: string
}

export interface DrawingParameterTextAnnotation extends DrawingParameters {
  topText?: string
  bottomText?: string
  leadAnchors: TextAnnotationLeadAnchor[]
  width: number
}

export interface DrawingParameterMeasurementLabel extends DrawingParameters {
  points: [PointArray, PointArray]
}

export interface Drawing<
  T =
    | DrawingParameterPolyline
    | DrawingParameterPolygon
    | DrawingParameterCircle
    | DrawingParameterRectangle
    | DrawingParameterTextAnnotation,
> {
  name: string
  drawing_type: DrawingType
  drawing_parameters: T
}
